/**
* 分页组件
*/ 
<template>
  <el-pagination
      background 
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      :current-page="childMsg.currentPage"
      layout="prev, pager, next"
      :page-size="childMsg.size || 10"
      :total="childMsg.totalNum">
  </el-pagination>
</template>
<script>
export default {
  name: 'Pagination',
  props: ['childMsg'],
  data() {
    return {
      pageparam: {
        currentPage: this.childMsg.currentPage
      }
    }
  },
  created() {

  },
  methods: {
    handleCurrentChange(val) {
      this.pageparam.currentPage = val;
      this.$emit('callFather', this.pageparam);
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue